import React, { useState, useRef, useEffect } from 'react';

// Generic imports
import _ from 'lodash';

// MUI imports
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTrash, faCircleDollarToSlot } from '@fortawesome/pro-light-svg-icons';

// Local imports
import { DisplayCurrencySettingsSection, BulkUpdateSettings } from './DisplayCurrencySettings.js';
import ConfirmDialog from '../components/ConfirmDialog.js';

function SectionSettingsDialog(props) {
    const { open, onClose, section, setSection, onDeleteSection, organization, exchangeRates, lockedExchangeRates, sx } = props;

    const [ selectedCategory, setSelectedCategory ] = useState('general');
    const [ innerSection, setInnerSection ] = useState(_.cloneDeep(section));
    const [ confirmDeleteOpen, setConfirmDeleteOpen ] = useState(false);
    const bulkUpdateRef = useRef(null);

    useEffect(() => {
        setSelectedCategory('general');
        setInnerSection(_.cloneDeep(section));
    }, [ section, open ]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg' sx={sx}>
            <DialogContent sx={{ display: 'flex', padding: 0 }}>
                <Box sx={{ width: '300px', borderRight: '1px solid #e0e0e0' }}>
                    <Typography variant='h6' sx={{ padding: '16px' }}>Section Settings</Typography>
                    <List>
                        <ListItem button selected={selectedCategory === 'general'} onClick={() => setSelectedCategory('general')}>
                            <FontAwesomeIcon icon={faCog} style={{ marginRight: '10px' }} />
                            <ListItemText primary='General' />
                        </ListItem>
                        <ListItem button selected={selectedCategory === 'currency'} onClick={() => setSelectedCategory('currency')}>
                            <FontAwesomeIcon icon={faCircleDollarToSlot} style={{ marginRight: '10px' }} />
                            <ListItemText primary='Currency' />
                        </ListItem>
                    </List>
                </Box>
                <Box sx={{ flexGrow: 1, padding: '16px', backgroundColor: 'rgb(250, 251, 252)', overflowY: 'auto' }}>
                    {selectedCategory === 'general' && (
                        <SectionSettingsGeneral section={innerSection} setSection={setInnerSection} />
                    )}
                    {selectedCategory === 'currency' && (
                        <>
                            <DisplayCurrencySettingsSection section={innerSection} setSection={setInnerSection} organization={organization} exchangeRates={exchangeRates} lockedExchangeRates={lockedExchangeRates} />
                            <BulkUpdateSettings section={innerSection} ref={bulkUpdateRef} />
                        </>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #e0e0e0', padding: '24px' }}>
                <Button
                    color='error'
                    startIcon={<FontAwesomeIcon icon={faTrash} />}
                    onClick={() => {
                        setConfirmDeleteOpen(true);
                    }}
                >
                    Delete Section
                </Button>
                <Box sx={{ flex: 1 }} />
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={() => {
                    setSection({ section: innerSection, currencyBulkUpdate: bulkUpdateRef.current?.get() });
                    onClose();
                }} sx={{ fontFamily: 'Poppins, sans-serif' }}>Save</Button>
            </DialogActions>
            <ConfirmDialog 
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
                onConfirm={onDeleteSection}
                color='error'
                sx={ sx?.zIndex ? { zIndex: sx.zIndex + 1 } : {}}
            >
                Are you sure you want to delete this section?
            </ConfirmDialog>
        </Dialog>
    );
}

function SectionSettingsGeneral(props) {
    const { section, setSection } = props;

    return (
        <Box>
            <TextField
                fullWidth
                label='Title'
                value={section.title}
                onChange={(e) => setSection({ ...section, title: e.target.value })}
                margin='normal'
            />
        </Box>
    )
}

export default SectionSettingsDialog;